import React from 'react'
import { Box, Typography } from '@mui/material'
import { MESSAGES } from '../messages/messages'

const AcceptSpinner = () => {
    return (
        <Box
            sx={{
                position: 'absolute',
                right: 0,
                bottom: 0,
                top: 0,
                left: 0,
                zIndex: 3001
            }}
        >
            <Box
                sx={{
                    backgroundColor: '#ffffff4d',
                    backdropFilter: 'blur(10px)',
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                    top: 0,
                    left: 0,
                    zIndex: '-1'
                }}
            />
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    flexDirection: 'column',
                    gap: 1,
                    position: 'fixed',
                    right: 0,
                    left: 0,
                    width: '100vw'
                }}
            >
                <Box
                    sx={{
                        width: '48px',
                        height: '48px',
                        borderStyle: 'solid',
                        borderColor: 'common.black.main',
                        borderWidth: '4px',
                        borderRadius: '50%',
                        borderBottomColor: 'transparent',
                        display: 'inline-block',
                        animation: 'rotation 1s linear infinite'
                    }}
                ></Box>
                <Typography
                    color="common.charcoal.main"
                    sx={{
                        typography: 'boldBody1',
                        letterSpacing: 0,
                        marginTop: 3
                    }}
                >
                    {MESSAGES.Processing}...
                </Typography>
                <Typography
                    color="common.charcoal.main"
                    sx={{
                        typography: 'regularBody2',
                        letterSpacing: 0
                    }}
                >
                    {MESSAGES.no_referesh_message}
                </Typography>
            </Box>
        </Box>
    )
}

export default AcceptSpinner
